/**
 * Help text for work-queue filters whose interaction is not self-evident from the field alone.
 *
 * Shared so the Bulk and Order Management queues describe the same filter the same way — both NDC
 * filters are backed by the identical core clause.
 */

export const NDC_FILTER_TOOLTIP =
  'Type and click enter to add each NDC. Filter supports multiple NDCs.';

export default NDC_FILTER_TOOLTIP;
